import React from 'react';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Plus from '@mui/icons-material/Add';
import Tooltip from '@mui/material/Tooltip';
import Button from 'react-bootstrap/Button';

export default function SuggestionSingleLine(props) {
	return (
		<div
			style={{
				marginLeft: '30%',
				display: 'flex',
				width: '60%',
			}}
		>
			<Tooltip title={props.text_lang.SEARCH.ADD_TO_GRAPH}>
				<IconButton
					color="primary"
					style={{ padding: 2 }}
					aria-label="search"
					onMouseDown={() => props.search(props.index, true)}
				>
					<Plus />
				</IconButton>
			</Tooltip>{' '}
			<Divider
				style={{
					height: 20,
					margin: 2,
				}}
				orientation="vertical"
			/>
			<Tooltip title={props.text_lang.SEARCH.NEW_SEARCH + props.tooltip_extra}>
				<Button
					style={{
						// color: props.color,
						margin: '0',
						// padding: '2px 4px',
						display: 'flex',
						width: '60%',
					}}
					size="sm"
					variant={props.variant}
					key={props.id}
					onMouseDown={() => props.search(props.index, false)}
				>
					<div
						style={{
							margin: 'auto',
						}}
					>
						{props.name}
					</div>
				</Button>
			</Tooltip>
		</div>
	);
}
